<div *ngIf="loadingService.loading$ | async" class="spinner-overlay">
  <div class="spinner"></div>
</div>

<div *ngIf="loadingService.loading$ | async" class="spinner-overlay">
  <mat-spinner></mat-spinner>
</div>
